<template>
  <div class="container">
    <b-row>
      <b-col lg="12">
        <h4 class="my-5 font-weight-light">
          Prices for Huntersville matches Carolina Lashes and South End matches
          Lewink Lashes & Brows—always giving you the premium experience you
          deserve!
        </h4>
      </b-col>
    </b-row>
    <b-row>
      <!--
      <b-col lg="12">
        <img
          src="https://www.dropbox.com/scl/fi/6cb8fq2805wx4fgmuy6jh/cmai_beauty_studio_davidson.jpeg?rlkey=7awfp29ajiy58t7468x3b8sn3&st=t02gexwc&raw=1"
          style="width: 100%"
          class="mb-2"
        />
        <img
          src="https://www.dropbox.com/scl/fi/xjza7h1pjywv6xb6o0sfe/cmai_beauty_studio_east_blvd.jpeg?rlkey=myi4b6jnicldzcbjgza0bt7gw&st=nuy2dnz4&raw=1"
          style="width: 100%"
          class="mb-2"
        />
      </b-col>
    -->

      <b-col lg="12" class="small-font">
        <!-- ===================== DAVIDSON ===================== -->
        <div class="card mb-5">
          <div class="card-header py-3">
            <h2 class="h5 brand-text mb-1">Davidson Location</h2>
            <div class="small text-muted">
              452 S Main St, Suite 105 A, Davidson NC 28036<br />
              Monday – Thursday | 10:00 am – 4:30 pm
            </div>
          </div>

          <div class="card-body p-3 p-md-4">
            <h3 class="section-title mb-3">Lashes Menu</h3>

            <div class="table-responsive mb-4">
              <table class="table table-hover mb-0">
                <thead>
                  <tr>
                    <th>Weeks Since Full Set</th>
                    <th class="text-center">Classic $200</th>
                    <th class="text-center">Hybrid $225</th>
                    <th class="text-center">Wispy Hybrid $250</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1 Week Refill (80–90% retention)</td>
                    <td class="text-center">65+</td>
                    <td class="text-center">75+</td>
                    <td class="text-center">85+</td>
                  </tr>
                  <tr>
                    <td>2 Weeks (70–80% retention)</td>
                    <td class="text-center">85+</td>
                    <td class="text-center">100+</td>
                    <td class="text-center">115+</td>
                  </tr>
                  <tr>
                    <td>3 Weeks (50–70% retention)</td>
                    <td class="text-center">105+</td>
                    <td class="text-center">120+</td>
                    <td class="text-center">135+</td>
                  </tr>
                  <tr>
                    <td>4 Weeks (40–50% retention)</td>
                    <td class="text-center">125+</td>
                    <td class="text-center">140+</td>
                    <td class="text-center">155+</td>
                  </tr>
                  <tr>
                    <td>Partial Set</td>
                    <td class="text-center">150</td>
                    <td class="text-center">170</td>
                    <td class="text-center">190</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-responsive mb-3">
              <table class="table table-hover mb-0 w-100">
                <thead>
                  <tr>
                    <th>Weeks Since Full Set</th>
                    <th class="text-center">% of Full Set</th>
                    <th class="text-center">Volume $250</th>
                    <th class="text-center">Mega Volume $300</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1 Week (80–90% retention)</td>
                    <td class="text-center">35–44%</td>
                    <td class="text-center">85+</td>
                    <td class="text-center">105+</td>
                  </tr>
                  <tr>
                    <td>2 Weeks (70–80% retention)</td>
                    <td class="text-center">45–54%</td>
                    <td class="text-center">115+</td>
                    <td class="text-center">135+</td>
                  </tr>
                  <tr>
                    <td>3 Weeks (50–70% retention)</td>
                    <td class="text-center">55–64%</td>
                    <td class="text-center">135+</td>
                    <td class="text-center">155+</td>
                  </tr>
                  <tr>
                    <td>4 Weeks (40–50% retention)</td>
                    <td class="text-center">65–75%</td>
                    <td class="text-center">155+</td>
                    <td class="text-center">180+</td>
                  </tr>
                  <tr>
                    <td>Partial Set</td>
                    <td class="text-center">No Refill</td>
                    <td class="text-center">190</td>
                    <td class="text-center">225</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="addons-box p-3 mb-4">
              <strong class="brand-text">Additional Services (Add-On):</strong>
              Wispy 25 &nbsp;|&nbsp; Deep Clean 20 &nbsp;|&nbsp; Removal 30
              &nbsp;|&nbsp; Pop of Color 20 &nbsp;|&nbsp; Foreign Fill 35
            </div>

            <h3 class="section-title mb-3">
              Permanent Make Up, Facials &amp; Lift
            </h3>

            <div class="row">
              <div class="col-md-6 col-lg-3 mb-4 mb-lg-0">
                <div class="service-block">
                  <h6>Permanent Make Up</h6>
                  <ul class="service-list">
                    <li>
                      <span>Hairstroke Brows</span
                      ><span class="price">580</span>
                    </li>
                    <li>
                      <span>Hybrid Hairstrokes</span
                      ><span class="price">620</span>
                    </li>
                    <li>
                      <span>Powder / Ombre' Brows</span
                      ><span class="price">580</span>
                    </li>
                    <li>
                      <span>Lip Blushing</span><span class="price">600</span>
                    </li>
                    <li>
                      <span>Upper Eyeliner</span><span class="price">475</span>
                    </li>
                    <li>
                      <span>Upper + Lower Eyeliner</span
                      ><span class="price">650</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-6 col-lg-3 mb-4 mb-lg-0">
                <div class="service-block">
                  <h6>Permanent Make Up Touch Up</h6>
                  <ul class="service-list">
                    <li>
                      <span>6–10 Wks Perfecting Touch-up</span
                      ><span class="price">200–250</span>
                    </li>
                    <li>
                      <span>Annual Brow Refresh</span
                      ><span class="price">325–400</span>
                    </li>
                    <li>
                      <span>Annual Lip Refresh</span
                      ><span class="price">350–450</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-6 col-lg-3 mb-4 mb-lg-0">
                <div class="service-block">
                  <h6>Facials</h6>
                  <ul class="service-list">
                    <li>
                      <span>Cmai Signature</span><span class="price">175</span>
                    </li>
                    <li>
                      <span>Sculptra H2 Filler</span
                      ><span class="price">190</span>
                    </li>
                    <li>
                      <span>Retinol Facial</span><span class="price">215</span>
                    </li>
                    <li>
                      <span>Microneedling</span><span class="price">225</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-6 col-lg-3">
                <div class="service-block">
                  <h6>Lift + Lamination + Tint</h6>
                  <ul class="service-list">
                    <li>
                      <span>Lash Lift</span><span class="price">100 | 115</span>
                    </li>
                    <li>
                      <span>Brows Lamination</span
                      ><span class="price">95 | 115</span>
                    </li>
                    <li>
                      <span>Lashes Tint</span><span class="price">35</span>
                    </li>
                    <li>
                      <span>Brows Tint</span><span class="price">30</span>
                    </li>
                    <li>
                      <span>Brows Shaping &amp; Tint</span
                      ><span class="price">60</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ===================== CHARLOTTE ===================== -->
        <div class="card mb-4">
          <div class="card-header py-3">
            <h2 class="h5 brand-text mb-1">Charlotte Location</h2>
            <div class="small text-muted">
              316 East Blvd, Suite 201C, Charlotte, NC 28203<br />
              Friday – Saturday
            </div>
          </div>

          <div class="card-body p-3 p-md-4">
            <h3 class="section-title mb-3">Lashes Menu</h3>

            <div class="table-responsive mb-4">
              <table class="table table-hover mb-0">
                <thead>
                  <tr>
                    <th>Weeks Since Full Set</th>
                    <th class="text-center">Classic $190</th>
                    <th class="text-center">Hybrid $215</th>
                    <th class="text-center">Wispy Hybrid $240</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1 Week Refill (80–90% retention)</td>
                    <td class="text-center">65+</td>
                    <td class="text-center">70+</td>
                    <td class="text-center">80+</td>
                  </tr>
                  <tr>
                    <td>2 Weeks (70–80% retention)</td>
                    <td class="text-center">80+</td>
                    <td class="text-center">95+</td>
                    <td class="text-center">110+</td>
                  </tr>
                  <tr>
                    <td>3 Weeks (50–70% retention)</td>
                    <td class="text-center">100+</td>
                    <td class="text-center">115+</td>
                    <td class="text-center">130+</td>
                  </tr>
                  <tr>
                    <td>4 Weeks (40–50% retention)</td>
                    <td class="text-center">120+</td>
                    <td class="text-center">135+</td>
                    <td class="text-center">150+</td>
                  </tr>
                  <tr>
                    <td>Partial Set</td>
                    <td class="text-center">145</td>
                    <td class="text-center">160</td>
                    <td class="text-center">180</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-responsive mb-3">
              <table class="table table-hover mb-0">
                <thead>
                  <tr>
                    <th>Weeks Since Full Set</th>
                    <th class="text-center">% of Full Set</th>
                    <th class="text-center">Volume $240</th>
                    <th class="text-center">Mega Volume $285</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1 Week Refill (80–90% retention)</td>
                    <td class="text-center">35–44%</td>
                    <td class="text-center">80+</td>
                    <td class="text-center">100+</td>
                  </tr>
                  <tr>
                    <td>2 Weeks (70–80% retention)</td>
                    <td class="text-center">45–54%</td>
                    <td class="text-center">110+</td>
                    <td class="text-center">130+</td>
                  </tr>
                  <tr>
                    <td>3 Weeks (50–70% retention)</td>
                    <td class="text-center">55–64%</td>
                    <td class="text-center">130+</td>
                    <td class="text-center">150+</td>
                  </tr>
                  <tr>
                    <td>4 Weeks (40–50% retention)</td>
                    <td class="text-center">65–75%</td>
                    <td class="text-center">150+</td>
                    <td class="text-center">170+</td>
                  </tr>
                  <tr>
                    <td>Partial Set</td>
                    <td class="text-center">No Refill</td>
                    <td class="text-center">180</td>
                    <td class="text-center">215</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="addons-box p-3 mb-4">
              <strong class="brand-text">Additional Services:</strong>
              Wispy 25 &nbsp;|&nbsp; Deep Clean 20 &nbsp;|&nbsp; Removal 30
              &nbsp;|&nbsp; Pop of Color 10 &nbsp;|&nbsp; Foreign Fill 35
            </div>

            <h3 class="section-title mb-3">
              Permanent Make Up, Facials &amp; Lift
            </h3>

            <div class="row">
              <div class="col-md-6 col-lg-3 mb-4 mb-lg-0">
                <div class="service-block">
                  <h6>Permanent Make Up</h6>
                  <ul class="service-list">
                    <li>
                      <span>Hairstroke Brows</span
                      ><span class="price">550</span>
                    </li>
                    <li>
                      <span>Hybrid Hairstrokes</span
                      ><span class="price">590</span>
                    </li>
                    <li>
                      <span>Powder / Ombre' Brows</span
                      ><span class="price">550</span>
                    </li>
                    <li>
                      <span>Lip Blushing</span><span class="price">575</span>
                    </li>
                    <li>
                      <span>Upper Eyeliner</span><span class="price">450</span>
                    </li>
                    <li>
                      <span>Upper + Lower Eyeliner</span
                      ><span class="price">620</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-6 col-lg-3 mb-4 mb-lg-0">
                <div class="service-block">
                  <h6>Permanent Make Up Touch Up</h6>
                  <ul class="service-list">
                    <li>
                      <span>6–10 Wks Perfecting Touch-up</span
                      ><span class="price">200–250</span>
                    </li>
                    <li>
                      <span>Annual Brow Refresh</span
                      ><span class="price">325–400</span>
                    </li>
                    <li>
                      <span>Annual Lip Refresh</span
                      ><span class="price">350–450</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-6 col-lg-3 mb-4 mb-lg-0">
                <div class="service-block">
                  <h6>Facials</h6>
                  <ul class="service-list">
                    <li>
                      <span>Cmai Signature Facial</span
                      ><span class="price">170</span>
                    </li>
                    <li>
                      <span>Sculptra H2 Filler Facial</span
                      ><span class="price">185</span>
                    </li>
                    <li>
                      <span>Retinol Facial</span><span class="price">210</span>
                    </li>
                    <li>
                      <span>Microneedling</span><span class="price">220</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="col-md-6 col-lg-3">
                <div class="service-block">
                  <h6>Lift + Lamination + Tint</h6>
                  <ul class="service-list">
                    <li>
                      <span>Lash Lift</span><span class="price">95 | 110</span>
                    </li>
                    <li>
                      <span>Brows Lamination</span
                      ><span class="price">90 | 110</span>
                    </li>
                    <li>
                      <span>Lashes Tint</span><span class="price">35</span>
                    </li>
                    <li>
                      <span>Brows Tint</span><span class="price">30</span>
                    </li>
                    <li>
                      <span>Brows Shaping &amp; Tint</span
                      ><span class="price">55</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <footer class="text-center pt-3 border-top">
          <p class="font-italic mb-3">
            Cmai Beauty Studio’s pricing reflects 14 years of expertise, premium
            products,<br class="d-none d-md-inline" />
            and an elevated studio experience designed to deliver exceptional
            results.
          </p>
        </footer>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Pricing"
};
</script>

<style scoped>
.small-font {
  font-size: 0.75rem;
}

.brand-text {
  color: #c45c4a !important;
}

.card {
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-radius: 12px;
  overflow: hidden;
}

.card-header {
  background-color: #f5efe9;
  border-bottom: 1px solid #e5e0dc;
}

.section-title {
  color: #c45c4a;
  font-weight: 600;
  font-size: 0.9rem;
  letter-spacing: 0.01em;
}

.table thead th {
  background-color: #f5efe9;
  color: #a3483a;
  font-weight: 600;
  white-space: nowrap;
  border-bottom-color: #e5e0dc;
  border-top: none;
}

.table td,
.table th {
  vertical-align: middle;
  border-color: #e5e0dc;
}

.table tbody tr:last-child td {
  border-bottom: none;
}

.addons-box {
  background-color: #f9f6f3;
  border-radius: 6px;
  color: #666;
}

.service-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.service-list li {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.4rem 0;
  border-bottom: 1px dashed #eee;
}

.service-list li:last-child {
  border-bottom: none;
}

.service-list .price {
  font-weight: 600;
  color: #222;
  white-space: nowrap;
}

.service-block h6 {
  color: #c45c4a;
  font-weight: 600;
  font-size: 0.7rem;
  border-bottom: 1px solid #e5e0dc;
  padding-bottom: 0.4rem;
  margin-bottom: 0.6rem;
}

footer {
  color: #666;
  font-size: 0.9rem;
}

footer a {
  color: #c45c4a;
  text-decoration: none;
}

footer a:hover {
  text-decoration: underline;
}
</style>
